import styled, { css } from "styled-components";
import { breakpoints, Text } from "iparque-components";
import { CSSProperties } from "react";
import {
  AppearFromBottomProps,
  getAnimationConfig,
} from "theme/staggeredAnimations";

export const lottieStyle: CSSProperties = {
  width: 220,
};

const appearFromBottom = css<AppearFromBottomProps>`
  opacity: 1;

  @media (min-width: ${breakpoints.md}) {
    opacity: 0;

    ${({ isSectionVisible, index }) =>
      isSectionVisible ? getAnimationConfig(index, { columns: 2 }) : ""};
  }

  @media (min-width: ${breakpoints.lg}) {
    ${({ isSectionVisible, index }) =>
      isSectionVisible ? getAnimationConfig(index, { columns: 3 }) : ""};
  }
`;

export const Container = styled.div`
  ${appearFromBottom}
`;

export const Body = styled(Text)`
  font-size: 16px;
`;
